import React from 'react';
import { Grid, styled } from '@mui/material';
import { Checkbox, Text } from 'library';
import { Role } from './models';

interface ISelectPermissionsProps {
    selectedRoles: number[];
    onRoleSelect: (id: number) => void;
    availableRoles: Role[];
}

export default function SelectRoles({ selectedRoles, onRoleSelect, availableRoles }: ISelectPermissionsProps) {
    return (
        <SelectionContainer container>
            <Grid item xs={12}>
                <Text variant="h2" bold>
                    Select Roles
                </Text>
            </Grid>
            {availableRoles.map((x) => (
                <Grid key={x.id} item sm={6} xs={12}>
                    <Checkbox
                        label={x.display_name}
                        checked={selectedRoles.includes(x.id)}
                        onChange={() => onRoleSelect(x.id)}
                        style={{ alignItems: 'flex-start' }}
                    />
                </Grid>
            ))}
        </SelectionContainer>
    );
}

const SelectionContainer = styled(Grid)({
    padding: '10px 0',
});
